// extracted by mini-css-extract-plugin
export var animationContainer = "_gd-0";
export var asteriskIcon = "_gd-8";
export var conversationLeftSection = "_gd-4";
export var conversationListItem = "_gd-3";
export var conversationMiddleSection = "_gd-5";
export var conversationRightSection = "_gd-6";
export var detailsContent = "_gd-1";
export var listContainer = "_gd-7";
export var modalContent = "_gd-2";